module.exports = __webpack_public_path__ + "img/movil.a84faaa7.png";